export const fullAccessPreferencesMenu = {
    "leads": "Leads",
    "clients": "Clients",
    "patentApplications": "Patent Applications",
    "trademarkApplications": "Trademark Applications",
    "forms": "Forms",
    "projects": "Projects"
}

export const analystAccessPreferencesMenu = {
    "projects": "Projects"
}

export const preferenceOptions = {
    leads: {
        "leadName": "Lead Name",
        "email": "Email",
        "source": "Source",
        "contactName": "Contact Name",
        "phone": "Phone",
        "note": "Note",
        "status": "Status",
        "province": "Province",
        "address": "Address",
        "createdAt": "Creation Date",
        "updatedAt": "Last Update",
    },
    clients: {
        "clientID": "Client ID",
        "companyName": "Client Name",
        "companyEmail": "Email",
        "companyPhoneNumber": "Phone",
        "province": "Province",
        "companyAddress": "Address",
        "companyRepresentative": "Representative",
        "createdAt": "Creation Date",
        "updatedAt": "Last Update",
    },
    forms: {
        "projectNumber": "Project Number",
        "companyName": "Client Name",
        "title": "Title",
        "status": "Status",
        "service": "Service",
        "createdAt": "Creation Date",
        "updatedAt": "Last Update",
        "submissionDate": "Submission Date",
        "approvalDate": "Approval Date",
    },
    projects: {
        "projType": "Service",
        "projNum": "Project Number",
        "projTitle": "Title",
        "submissionDate": "Submission Date",
        "clientNumber": "Client Number",
        "clientName": "Client Name",
        "dueDate": "Analyst Deadline",
        "clientDeadline": "Client Deadline",
        "managerName": "Manager",
        "ndaStatus": "NDA Status",
        "ndaURL": "NDA Link",
        "contractStatus": "Contract Status",
        "contractURL": "Contract Link",
        "firstInvoiceStatus": "First Invoice Status",
        "firstInvoiceURL": "First Invoice Link",
        // "firstPaymentStatus": "First Payment Status",
        "intakeFormStatus": "Intake Form Status",
        "formURL": "Form Link",
        "projectStatus": "Project Status",
        "assignedAnalystName": "Analyst",
        "projectReportStatus": "Project Report Status",
        "projectReportURL": "Project Report Link",
        "secondInvoiceStatus": "Second Invoice Status",
        "secondInvoiceURL": "Second Invoice Link",
        // "secondPaymentStatus": "Second Payment Status",
        // "searchPaymentStatus": "Search Payment Status",
        "otherURLs": "Other Links",
        "createdAt": "Creation Date",
        "updatedAt": "Last Update",
    },
    patentApplications: {
        "RPNumber": "RP Number",
        "title": "Title",
        "clientName": "Client Name",
        "clientID": "Client ID",
        "applicants": "Applicants",
        "inventors": "Inventors",
        "filingFirm": "Filing Firm",
        "firmRefNumber": "Filing Firm Reference Number",
        "attorney": "Attorney",
        "attorneyRefNumber": "Attorney Reference Number",
        "contact": "Client Contact",
        "country": "Country",
        "patentType": "Patent Type",
        "applicationType": "Application Type",
        "applicationStatus": "Application Status",
        "earliestPriorityDate": "Earliest Priority Date",
        "earliestPriorityApplicationNumber": "Earliest Priority Application Number",
        "lastAction": "Last Action",
        "nextAction": "Next Action",
        "nextActionDueDate": "Next Action Due Date",
        "filingStatus": "Filing Status",
        "entityStatus": "Entity Status",
        "applicationNumber": "Application Number",
        "filingDate": "Filing Date",
        "plannedFilingDate": "Planned Filing Date",
        "officialFilingDate": "Official Filing Date",
        "nationalEntryDate": "National Entry Date",
        "publicationDate": "Publication Date",
        "estimatedFirstOfficeActionDate": "Estimated First Office Action Date",
        "officialOfficeActionDate": "Official Office Action Date",
        "allowanceDate": "Allowance Date",
        "requestExaminerInterview": "Request Examiner Interview",
        "examinerInterviewDate": "Examiner Interview Date",
        "filedRCE": "Filed RCE",
        "RCEFiledDate": "RCE Filed Date",
        "issueFeePaymentDate": "Issue Fee Payment Date",
        "issueDate": "Issue Date",
        "patentNumber": "Patent Number",
        "maintenanceFeeDueDate": "Maintenance Fee Due Date",
        "maintenanceFeeStatus": "Maintenance Fee Status",
        "expirationDate": "Expiration Date",
        "abandonedDate": "Abandoned Date",
        "PAIRReg": "PAIR Registration",
        "notes": "Notes",
        "driveFolderLocation": "Drive Folder Location",
        "createdAt": "Creation Date",
        "updatedAt": "Last Update",
    },
    trademarkApplications: {
        "RPNumber": "RP Number",
        "clientName": "Client Name",
        "clientID": "Client ID",
        "applicationType": "Application Type",
        "filingFirm": "Filing Firm",
        "firmRefNumber": "Filing Firm Reference Number",
        "contact": "Client Contact",
        "applicants": "Applicants",
        "applicantAddress": "Applicant Address",
        "trademarkClasses": "Trademark Classes",
        "highlyRelevantTrademarkClass": "Highly Relevant Trademark Class",
        "trademarkType": "Trademark Type",
        "applicationNumber": "Application Number",
        "filing": "Filing",
        "trademarkDescription": "Trademark Description",
        "priorityDate": "Priority Date",
        "priorityApplication": "Priority Application",
        "filingDate": "Filing Date",
        "registrationNumber": "Registration Number",
        "feesPaid": "Fees Paid",
        "registrationDate": "Registration Date",
        "nationalEntryDate": "National Entry Date",
        "applicationStatus": "Application Status",
        "examinationByOffice": "Examination By Office",
        "approvalOrDenial": "Approval Or Denial",
        "NOA": "NOA",
        "maintenanceOfRegistration": "Maintenance Of Registration",
        "lastAction": "Last Action",
        "nextAction": "Next Action",
        "nextActionDueDate": "Next Action Due Date",
        "notes": "Notes",
        "driveFolderLocation": "Drive Folder Location",
        "trademarkClassesForSearch": "Trademark Classes For Search",
        "trademarkClassesForFiling": "Trademark Classes For Filing",
        "createdAt": "Creation Date",
        "updatedAt": "Last Update",
    }
}